import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  FaIdCard,
  FaSearch,
  FaWifi,
  FaEdit,
  FaCreditCard,
  FaQrcode
} from "react-icons/fa";
import "bootstrap/dist/css/bootstrap.min.css";
import { ManageBranchService } from "../api/services";
const BranchCardDashboard = () => {
  const navigate = useNavigate();
  const [showPopup, setShowPopup] = useState(false);
  const [isCardAvailable, setIsCardAvailable] = useState(false);
  const [newCardId, setNewCardId] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [newCardNumber, setNewCardNumber] = useState("");
  const [IsLoading, setIsLoading] = useState(false);
  const [form, setForm] = useState({
    studentName: "",
    parentName: "",
    relationship: "",
    mobile1: "",
    mobile2: "",
    mobile3: "",
    mobile4: "",
    cardNumber: ""
  });

  const [errors, setErrors] = useState({});

  const menuItems = [
    {
      label: "Card To Student",
      icon: <FaIdCard size={40} />,
      onClick: () => {
        setForm({
            studentName: "",
            parentName: "",
            relationship: "",
            mobile1: "",
            mobile2: "",
            mobile3: "",
            mobile4: "",
            cardNumber: ""
        });
        setErrors({});
        setShowPopup(true);
        setIsCardAvailable(false)
        setNewCardNumber("")
}

    },
    { label: "Search Card", icon: <FaSearch size={40} />,
      onClick: () => navigate("/BranchUser/CardManagement/SearchCards")
    },
    {
        label: "Card Transactions",
        icon: <FaCreditCard size={40} />,
        onClick: () => navigate("/BranchUser/CardManagement/Transactions")
    }

  ];
   const handleCardNumberChange = (value) => {
    setNewCardNumber(value);
    setForm(prev =>({
      ...prev,
      cardNumber:value
      }));
    if (error) {
      setError("");
    }
  };

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  // -------------------------
  //   FORM VALIDATION LOGIC
  // -------------------------
  const preparePostData = () => {
    return {
            student_name: form.studentName,
            parent_name: form.parentName,
            parent_relation: form.relationship.toUpperCase(),
            mobile_1: form.mobile1 || null,
            mobile_2: form.mobile2 || null,
            mobile_3: form.mobile3 || null,
            mobile_4: form.mobile4 || null,
            card_id: Number(newCardId) // convert to number
        };
    };
const handleVerifyCard = (newCardNumber) => {

  if (!newCardNumber?.trim()) {
    setErrors(prev => ({
      ...prev,
      cardNumber: "Card Number is required",
    }));
    return;
  }

  setErrors(prev => ({
    ...prev,
    cardNumber: "",
  }));
  setForm(prev =>({
  ...prev,
  cardNumber:newCardNumber
  }));

  const payload = {
    card_name: newCardNumber,
  };
  setIsLoading(true);
  ManageBranchService.VerifyCard(payload).then((res) => {
            
            if (res.data.code == "201") {
                    alert(res.data.error_message);
            }else if(res.data.code == "200"){
                setIsCardAvailable(res.data.results['isCardAvailable'])
                setNewCardId(res.data.results['card_id'])
                debugger
                if(!(res.data.results['isCardAvailable'])){
                  alert("Card is not available")
                }
            } else {
                alert(res.data.error_message);
            }
            setIsLoading(false);

          })
          .catch((err) => {
            console.error("Fetch failed:", err);
            setError('Failed to fetch student data');
            setIsLoading(false);
            
          })
          
};

  const validate = () => {
    let newErrors = {};

    if (!form.studentName.trim()) newErrors.studentName = "Student Name is required";
    if (!form.parentName.trim()) newErrors.parentName = "Parent Name is required";
    if (!form.relationship.trim()) newErrors.relationship = "Relationship is required";

    const mobiles = [form.mobile1, form.mobile2, form.mobile3, form.mobile4];
    const anyMobileExists = mobiles.some((m) => m.trim() !== "");

    if (!anyMobileExists)
      newErrors.mobile1 = "At least one mobile number required";

    mobiles.forEach((m, index) => {
      if (m && !/^\d{10}$/.test(m)) {
        newErrors[`mobile${index + 1}`] = "Invalid mobile number";
      }
    });
    if (!form.cardNumber.trim()) newErrors.cardNumber = "Card Number is required";

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };
  const submitstudentData = () =>{
     const postData = preparePostData();
        setIsLoading(true);
        try {
            ManageBranchService.AddCardToStudent(postData)
                .then((res) => {
                if (res.data.code == "201") {
                    alert(res.data.error_message);
                }else if(res.data.code == "200"){
                    alert(res.data.results);
                } else {
                    alert(res.data.error_message);
                }
                })
                .catch((err) => {
                    console.error('Failed to Register Student:', err);
                });
                
            } catch (err) {
                console.error(err);
                alert("Error occurred while registering student");
            }
            finally{
                  setIsLoading(false);
                  setShowPopup(false);
            }
  }
  const handleSubmit = () => {
    debugger
    if (!validate()){
        return false;
    } else{
          if(isCardAvailable){
              submitstudentData()
          }else{
            alert("Verify Card")
          }
       
    }

  };
  return (
    <div className="container mt-4">
       {/* Loader */}
      <div className="loader" style={IsLoading ? {} : { display: "none" }}>
        <div className="lds-spinner">
          {Array.from({ length: 12 }).map((_, i) => (
            <div key={i}></div>
          ))}
        </div>
      </div>
      <button className="btn btn-outline-secondary mb-3" onClick={() => navigate(-1)}>
          ← Back
        </button>
      {/* Header */}
      <div className="mb-4" style={{ 
                background: "linear-gradient(to bottom right, #ff7e5f, #feb47b)",
                borderRadius: "16px",
                padding: "30px"
                }}>
        <h4 className="m-0"  style={{
                    margin: 0,
                    fontSize: "28px",
                    fontWeight: "700",
                    color: "#ffffff",
                  }}>Card Management</h4>
      </div>
 
      {/* Menu Grid */}
      <div className="row g-3">
        {menuItems.map((item, index) => (
          <div key={index} className="col-6">
            <div
              className="card shadow-sm p-4 text-center"
              style={{ borderRadius: "15px", cursor: "pointer" }}
              onClick={item.onClick}
            >
              <div className="mb-3">{item.icon}</div>
              <h6 className="fw-bold">{item.label}</h6>
            </div>
          </div>
        ))}
      </div>

      {/* -------------------- POPUP MODAL --------------------- */}
      {showPopup && (
        <div
          className="modal d-block"
          style={{ background: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content p-3">

              <div className="modal-header bg-warning text-white" style={{ 
                background: "linear-gradient(to bottom right, #ff7e5f, #feb47b)",
                borderRadius: "8px",
                padding: "15px"
                }}>
                <h5 className="modal-title">Register Student</h5>
                <button className="btn-close" onClick={() => setShowPopup(false)}></button>
              </div>

              <div className="modal-body">

                {/* ---------- ROW 1: Student + Parent ---------- */}
                <div className="row">
                    <div className="col-md-6">
                    <strong className="fw-bold">Student Name</strong>
                    <input
                        type="text"
                        name="studentName"
                        className="form-control mb-2"
                        value={form.studentName}
                        onChange={handleChange}
                    />
                    {errors.studentName && <p className="text-danger small">{errors.studentName}</p>}
                    </div>

                    <div className="col-md-6">
                    <strong className="fw-bold">Parent Name</strong>
                    <input
                        type="text"
                        name="parentName"
                        className="form-control mb-2"
                        value={form.parentName}
                        onChange={handleChange}
                    />
                    {errors.parentName && <p className="text-danger small">{errors.parentName}</p>}
                    </div>
                </div>

                {/* ---------- ROW 2: Relationship ---------- */}
                <div className="row mt-2">
                <div className="col-md-6">
                    <label className="fw-bold">Relationship</label>
                    <select
                    name="relationship"
                    className="form-control mb-2"
                    value={form.relationship}
                    onChange={handleChange}
                    >
                    <option value="">Select Relationship</option>
                    <option value="FATHER">FATHER</option>
                    <option value="MOTHER">MOTHER</option>
                    <option value="GUARDIAN">GUARDIAN</option>
                    </select>

                    {errors.relationship && (
                    <p className="text-danger small">{errors.relationship}</p>
                    )}
                </div>
                </div>


                {/* ---------- MOBILE NUMBERS 2-COLUMNS ---------- */}
                <h6 className="mt-3 fw-bold">Mobile No. Allowed to Call</h6>

                <div className="row">
                    {[1, 2, 3, 4].map((i) => (
                    <div key={i} className="col-md-6">
                        <label className="fw-bold">Mobile Number {i}</label>
                        <input
                        type="text"
                        name={`mobile${i}`}
                        className="form-control mb-2"
                        value={form[`mobile${i}`]}
                        onChange={handleChange}
                        maxLength={10}
                        />
                        {errors[`mobile${i}`] && (
                        <p className="text-danger small">{errors[`mobile${i}`]}</p>
                        )}
                    </div>
                    ))}
                </div>

  {/* ---------- CARD ---------- */}
  <h6 className="mt-3 fw-bold">Card To Issue</h6>

  <div className="row">
    <div className="col-md-8">
      <label className="fw-bold">Card Number</label>
      <input
        type="text"
        name="cardNumber"
        className="form-control"
        value={newCardNumber}
        onChange={(e) => handleCardNumberChange(e.target.value)}
       
      />
      {errors.cardNumber && (
        <p className="text-danger small">{errors.cardNumber}</p>
      )}
    </div>

    {/* Verify Button right side */}
    <div className="col-md-4 d-flex align-items-end">
       <a 
                style={{ 
                color: isCardAvailable ? "green" : "#2563eb",
                textAlign: "center",
                display: "block",
                cursor: isCardAvailable ? "default" : "pointer",
                fontWeight:"600" 
                }}
                onClick={() =>  !isCardAvailable &&handleVerifyCard(newCardNumber)}
            >
                {isCardAvailable ? "Verified" : "Verify Card"}
            </a>
    </div>
  </div>

</div>


              {/* Submit Button */}
               <div style={{ display: 'flex', justifyContent: 'center', marginTop: '16px' }}>
              <button
                onClick={handleSubmit}
                disabled={IsLoading}
                style={{
                  background: 'linear-gradient(to bottom right, #ff7e5f, #feb47b)',
                  fontWeight: '600',
                  padding: '10px 16px',
                  color: 'white',
                  fontSize: '18px',
                  borderRadius: '8px',
                  border: 'none',
                  cursor: 'pointer',
                  width: 'fit-content'
                }}
              >
                SUBMIT
              </button>
            </div>
            </div>
          </div>
        </div>
      )}

    </div>
  );
};

export default BranchCardDashboard;
